import { z } from 'zod';

export const DrawingSchema = z.object({
  id: z.string().uuid(),
  project_id: z.string().uuid(),
  filename: z.string(),
  original_name: z.string(),
  mime_type: z.string(),
  page_count: z.number().int().default(1),
  sheet_number: z.string().nullable(),
  sheet_title: z.string().nullable(),
  storage_path: z.string(),
  thumbnail_path: z.string().nullable(),
  uploaded_at: z.string().datetime(),
});

export const DrawingPageSchema = z.object({
  id: z.string().uuid(),
  knowledge_item_id: z.string().uuid(),
  page_number: z.number().int(),
  image_path: z.string(),
  width: z.number().int(),
  height: z.number().int(),
});

export type Drawing = z.infer<typeof DrawingSchema>;
export type DrawingPage = z.infer<typeof DrawingPageSchema>;
